<template>
    <div class="slide" :style="style">
        <div class="overlay" v-if="withOverlay"></div>
        <div class="caption"><slot></slot></div>
    </div>
</template>
<script>
    import Path from '../../mixins/Path.vue';
    export default {
        mixins: [Path],
        props: {
            withOverlay: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            style() {
                return "background-image: url('" + this.path + "');";
            }
        }
    }
</script>